import styled from 'styled-components';

import { SkeletonImage } from '@xing-com/skeleton';
import { spaceXXL } from '@xing-com/tokens';

export const LoadingIntroTitle = styled(SkeletonImage)`
  margin: ${spaceXXL} 0;
`;
